import { RootErrorFallback } from '@eventbrite/eds-structure';
import { useFeatureFlags } from '@eventbrite/feature-flag-utils';
import { RenderGlobalNavOrUndefined } from '@eventbrite/global-nav';
import { SiteStructure } from '@eventbrite/site-structure';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useEnvContext } from '../context/env';
import { FooterLinks } from '../types';

interface ThingsToDoBasePageProps {
    footerLinks: FooterLinks;
}

export const ThingsToDoBasePage: React.FunctionComponent<
    ThingsToDoBasePageProps
> = (props) => {
    const envContext = useEnvContext();
    const { enableIaGlobalNav } = useFeatureFlags();

    return (
        <SiteStructure
            env={envContext.env}
            request={envContext.request}
            user={envContext.user}
            footerLinks={props.footerLinks}
            fullScreenMain={true}
            globalHeader={RenderGlobalNavOrUndefined({
                config: {
                    user: envContext.user,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    env: envContext.env!,
                    positionSticky: { mobile: false, desktop: false },
                },
                featureFlag: enableIaGlobalNav,
            })}
        >
            <Sentry.ErrorBoundary
                fallback={<RootErrorFallback />}
                onError={(error) => {
                    if (process.env.NODE_ENV !== 'production') {
                        throw error;
                    }
                }}
            >
                {props.children}
            </Sentry.ErrorBoundary>
        </SiteStructure>
    );
};
